import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Text } from '../Donee/components/common/Text/Text';
import { webConfig } from '../../utils/webConfig';
import { logError } from '../../utils/logError';

class QRCodeErrorBoundary extends React.Component<
    { fallback: React.ReactNode; children: React.ReactNode },
    { hasError: boolean }
> {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error: Error) {
        logError('QRCodeSection render failed, using fallback:', error);
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
}

const FallbackImage = () => (
    <img
        src={webConfig.qrCodeUrl}
        alt="App QR code"
    />
);

interface QRCodeSectionProps {
    className?: string;
    text?: string;
    value?: string;
    size?: number;
}

const QRCodeSection: React.FC<QRCodeSectionProps> = ({
    className,
    text = 'Scan QR code with your phone to download the app',
    value,
    size = 180,
}) => (
    <div
        className={`flex-1 gap-4 flex flex-col items-center justify-center ${
            className ?? ''
        }`}
    >
        <Text
            variant="medium"
            weight="semiBold"
        >
            {text}
        </Text>
        {value ? (
            <QRCodeErrorBoundary fallback={<FallbackImage />}>
                <QRCodeSVG
                    value={value}
                    size={size}
                    level="M"
                    includeMargin
                />
            </QRCodeErrorBoundary>
        ) : (
            <FallbackImage />
        )}
    </div>
);

export default QRCodeSection;
